if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      super();

      this._prefix = window.KT_PREFIX || '';

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll(`.${this._prefix}announcement`);
      this.nextButton = this.querySelector(`.${this._prefix}announcement-bar__content-nav--right`);
      this.prevButton = this.querySelector(`.${this._prefix}announcement-bar__content-nav--left`);

      this.index = 0;
      this.length = this.content.length;

      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplayIntervalDelay = this.dataset.autoplayInterval
        ? parseInt(this.dataset.autoplayInterval, 10)
        : 5000;

      this._autoplayInterval = null;
      this._paused = false;

      // Wer Bewegung abbestellt hat, bekommt keinen selbsttaetigen Wechsel
      // und keinen weichen Scroll.
      this.reducedMotion = window.matchMedia
        ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
        : false;

      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', () => {
          this.stopAutoplay();
          this.#changeSlide('next');
        });
      }

      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', () => {
          this.stopAutoplay();
          this.#changeSlide('prev');
        });
      }

      // Die Botschaft soll lesbar bleiben, solange jemand daraufzeigt oder
      // mit der Tastatur darin steht.
      this.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.addEventListener('mouseleave', () => this.resumeAutoplay());
      this.addEventListener('focusin', () => this.pauseAutoplay());
      this.addEventListener('focusout', () => this.resumeAutoplay());

      this.#syncNavState();

      if ( this.autoplayEnabled && this.length > 1 && ! this.reducedMotion ) {
        this.startAutoplay();
      }
    }

    startAutoplay() {
      this.stopAutoplay();

      const tick = () => {
        if ( this._paused ) return;
        this.#changeSlide('next');
      };

      this._autoplayInterval = setInterval(tick, this.autoplayIntervalDelay);
    }

    pauseAutoplay() {
      this._paused = true;
    }

    resumeAutoplay() {
      this._paused = false;
    }

    stopAutoplay() {
      if ( this._autoplayInterval ) {
        clearInterval(this._autoplayInterval);
        this._autoplayInterval = null;
      }
    }

    // Beide Pfeile laufen im Kreis. Vorher stand der linke Pfeil dauerhaft
    // auf --disabled, war dabei aber weiter im Tabstopp - und die zweite
    // Botschaft bekam praktisch niemand zu sehen.
    #changeSlide(direction) {
      if (!this.slider || !this.length) return;

      if ( direction === 'next' ) {
        this.index = (this.index + 1) % this.length;
      } else if ( direction === 'prev' ) {
        this.index = (this.index - 1 + this.length) % this.length;
      }

      this.#syncNavState();

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: this.reducedMotion ? 'auto' : 'smooth'
      });
    }

    // Bei einer einzigen Botschaft sind die Pfeile echt deaktiviert - also
    // mit disabled-Attribut und ohne Tabstopp, nicht nur ausgegraut.
    #syncNavState() {
      const singular = this.length < 2;
      [this.nextButton, this.prevButton].forEach(btn => {
        if ( ! btn ) return;
        btn.classList.toggle(`${this._prefix}announcement-bar__content-nav--disabled`, singular);
        btn.disabled = singular;
        if ( singular ) {
          btn.setAttribute('aria-disabled', 'true');
        } else {
          btn.removeAttribute('aria-disabled');
        }
      });
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

  }

  if ( typeof customElements.get('announcement-bar') === 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}